import { ReactPropTypes, FunctionComponent } from 'react';
import React from 'react';

type ImageProps = {
  src?: string
}
export const Image: FunctionComponent<ImageProps & React.DetailedHTMLProps<React.CanvasHTMLAttributes<HTMLCanvasElement>, HTMLCanvasElement>> = ({src, ...props}) => {
  return <canvas {...props} style={{...(props.style ? props.style : {}), ...{backgroundImage: src ? `url(${src})` : '', backgroundSize: 'cover', display: 'block'}}} />
}